import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ProductStatus } from '@interfaces/global.interface';

const PLACEHOLDER_IMAGE_URL = 'assets/images/image-placeholder.jpg';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [
    RouterLink,
  ],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.css',
})
export class ProductCardComponent {
  public name = input.required<string>();
  public price = input.required<number | string>();
  public imageUrl = input<string | null | undefined>(undefined);
  public slug = input.required<string>();
  public isFeatured = input<boolean>(false);
  public status = input<ProductStatus>();

  private failedImageUrl: string | null = null;

  public getSafeImageUrl(): string {
    const imageUrl = this.imageUrl();

    if (!imageUrl || imageUrl === this.failedImageUrl) {
      return PLACEHOLDER_IMAGE_URL;
    }

    return imageUrl;
  }

  public onImageError(): void {
    this.failedImageUrl = this.imageUrl() ?? null;
  }
}
